<template>
<div>
  <div class="row">
    <div class="col">
      <h4><b>Scores and Templates</b></h4>
      <p>Scores are taken for students within units. The data recorded is determined by the score template.</p>
    </div>
  </div>
  <div class="row text-left">
    <div class="col">
      <h5>Score Templates</h5>
      <p>
        Score templates are used to define what data is kept each time a score is entered (similar to Google Forms). Each template made is reusable by everyone in the school so it is important to give it a name that means something like "Dibels Words per Minute and Accuracy", "Simple Score Out Of 20", etc. Score templates consist of 1 or more score inputs that determine what data is entered for the score.
      </p>
      <h5>Score Input</h5>
      <p>
        Score inputs are a single point of data taken every time a score is added for a student in a unit. Score inputs can be one of the following types:
        <ul>
          <li v-for="templateInputType in TemplateInputTypes.slice().sort($orderByOrder)" :key="templateInputType.Template_Input_Type_Id">
            {{ templateInputType.Title }}: {{ templateInputType.Description }}
          </li>
        </ul>
        Each score input has a request. The <b>Request</b> is the prompt that appears when a user is entering data for that input. Multiple score inputs can be added to a score template when more than one data point is scored for an assignment.
      </p>
      <h5>Score Entering</h5>
      <p>
        Each score entered has the option of adding an assignment name for that score. The assignment name is not required. 
        When scores are displayed they are displayed in order by date. 
        Scores can be entered for a student in multiple places:
        <br><b>Dashboard:</b> Scores can be added to students that you have starred and appear on your dashboard. Subjects and units will be listed below each student's name. When a unit is clicked it will take you to a page showing all the data for that student in that unit. Clicking the add score button allows you to add a new score.  
        <br><b>Students:</b> Scores can be added when you are on the Students page. Subjects and units will be listed below each student's name. When a unit is clicked it will take you to a page showing all the data for that student in that unit. Clicking the add score button allows you to add a new score.  
        <br><b>Specific Student:</b> Scores can be added when you are on a specific student's page. Their subjects and units will be listed below their name. When a unit is clicked it will take you to a page showing all the data for that student in that unit. Clicking the add score button allows you to add a new score.  
        <br><b>Subjects:</b> Scores can be added when you are on the Subjects page. Each subject and unit is listed out on the page. Each unit that you have permission to add data to will have the button <button class="btn btn-sm btn-primary py-0">Add Data</button>. When this is clicked, there will be a popup to select the students for which you would like to add a score. Then each page will have each selected student so that you can add a score for multiple students at once. This works well when you have multiple students doing the same assignment and therefore can add all of their scores at the same time.
      </p>
      <h5>Score Example</h5>
      <p>
        As an example, let's go through the process of keeping scores when using Dibels. 
        In this example we will be recording scores for students using Dibles to practice reading. 
        We will be recording data in words per minute and their reading accuracy in a percentage. 
        First we would create a unit and give it a name like "Dibels". 
        In order to keep scores for this unit, we would create a score template and name it something like "Dibels Words per Minute and Accuracy". 
        To record Words per Minute, we would add an input of type Score (does not have a set amount of right answers). 
        The request would be Words per Minute because that is what we would want to appear when we are entering that data. 
        We would then add another input to the same template for Reading Accuracy. 
        The type would be Percentage and the request would be "Reading Accuracy".
        When the template is created it can be selected as the template to use for our new unit Dibels.
        When the unit is created and students assigned to it, we can then keep scores.
      </p>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    TemplateInputTypes: Array
  }
}
</script>